<app-action
    icon="warning_amber"
    [highlightIcon]="true"
    [tooltip]="'warning_click_for_details' | translate"
    (onExecute)="showWarning()"
    *ngIf="isWarningApplicable">
</app-action>